import { render, staticRenderFns } from "./dataAPIList.vue?vue&type=template&id=7a21deb8"
import script from "./dataAPIList.vue?vue&type=script&lang=js"
export * from "./dataAPIList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports